import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService, { setAuthToken } from "./APIService";
import DebugService from "./DebugService";

/**
 * @description User Management Api Service
 */
const UserManagementApiService = {

  getData: async () => {
    try {
      let url = APIConstants.ENDPOINT_USERS

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['ownerId']) {
          url += `?ownerId=${parseToJson['ownerId']}`
        }
      }

      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`User Management Api Service: Error Caught while fetching data`, err)
    }
  },

  saveData: async (apiUrl, data) => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      let url = apiUrl

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`User Management Api Service: Error caught while saving data`, err)
    }
  },


}

export default UserManagementApiService;
